export const SmallCheckOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clipPath="url(#clip0_3410_12341)">
      <path
        d="M1.875 6.75L4.5 9.375L10.5 3.375"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3410_12341">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
